import { render } from "./ThreatDetails.vue?vue&type=template&id=4624f34a&scoped=true"
import script from "./ThreatDetails.vue?vue&type=script&lang=js"
export * from "./ThreatDetails.vue?vue&type=script&lang=js"

import "./ThreatDetails.vue?vue&type=style&index=0&id=4624f34a&scoped=true&lang=css"

import exportComponent from "/usr/frontend/src/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4624f34a"]])

export default __exports__